module.exports = __webpack_public_path__ + "img/RS-J-13.60163c38.svg";